const newIframe = {
    openBoxoffice: false
};

export default newIframe;